//Obras
export const SINGLE_PROYECTO_RECEIVED = "SINGLE_PROYECTO_RECEIVED";
export const ULTIMO_AVANCE_RECEIVED = "ULTIMO_AVANCE_RECEIVED";
export const SET_PROPERTY_PROYECTO = "SET_PROPERTY_PROYECTO";
export const CREATE_NUEVA_PROYECTO = "CREATE_NUEVA_PROYECTO";
export const PROYECTOS_RECEIVED = "PROYECTOS_RECEIVED";
export const DELETE_PROYECTO = "DELETE_PROYECTO";
export const EDIT_PROYECTO = "EDIT_PROYECTO";
export const VIEW_OPTIONS = "VIEW_OPTIONS";
export const HIDE_OPTIONS = "HIDE_OPTIONS";
export const AVANCES_DIA_RECEIVED = "AVANCES_DIA_RECEIVED";
export const PROYECCION_RECEIVED = "PROYECCION_RECEIVED";
export const AVANCE_FINANCIERO_RECEIVED = "AVANCE_FINANCIERO_RECEIVED";
export const HISTORIAL_RECEIVED = "HISTORIAL_RECEIVED";
